var __jsx = React.createElement;
import React, { useState, useEffect } from "react";
import dynamic from "next/dynamic";
import Head from "next/head";
import { useStore } from "@dp/state";
import { observer } from "mobx-react-lite";
import { PageLayout } from "../../util/constants";
var Reorder = dynamic(function () {
  return import("@dp/xcomp").then(function (mod) {
    return mod.Reorder;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@dp/xcomp")];
    }
  }
});
var ReOrderPage = function ReOrderPage(props) {
  var _store$menuList;
  var store = useStore();
  var brandCodeDesc = store === null || store === void 0 || (_store$menuList = store.menuList) === null || _store$menuList === void 0 || (_store$menuList = _store$menuList.appAttributes) === null || _store$menuList === void 0 || (_store$menuList = _store$menuList.concept) === null || _store$menuList === void 0 ? void 0 : _store$menuList.conceptCodeDesc;
  var _useState = useState(""),
    title = _useState[0],
    setTitle = _useState[1];
  useEffect(function () {
    var getPageTitle = function getPageTitle() {
      return brandCodeDesc ? "Reorder A Meal | ".concat(brandCodeDesc) : "Reorder A Meal";
    };
    setTitle(getPageTitle());
  }, [brandCodeDesc]);
  useEffect(function () {
    var _store$user;
    store === null || store === void 0 || (_store$user = store.user) === null || _store$user === void 0 || (_store$user = _store$user.analyticsModel) === null || _store$user === void 0 || _store$user.dispatchPageViewEvent();
  }, []);
  return __jsx(React.Fragment, null, __jsx(Head, null, __jsx("title", null, title)), __jsx(Reorder, {
    name: "Menu"
  }));
};
ReOrderPage.layout = PageLayout.NB_LAYOUT;
ReOrderPage.layoutProps = {
  analyticsData: {
    pageName: "reorder",
    pageType: "reorder"
  }
};
export default observer(ReOrderPage);